import React from 'react';

interface SEOArticleProps {
    title: string;
    sections: {
        heading: string;
        content: React.ReactNode;
    }[];
}

export default function SEOArticle({ title, sections }: SEOArticleProps) {
    return (
        <div style={{ 
            lineHeight: '1.8', 
            color: '#334155', 
            fontSize: 'var(--fs-base)',
            fontFamily: 'var(--font-sans)'
        }}>
            <h2 style={{ 
                fontSize: 'var(--fs-3xl)', 
                fontWeight: 900, 
                marginBottom: 'clamp(1.5rem, 4vh, 2.5rem)', 
                color: '#0f172a', 
                textAlign: 'center',
                letterSpacing: '-0.04em'
            }}>
                {title}
            </h2>

            {sections.map((section, idx) => (
                <section key={idx} style={{ marginBottom: 'clamp(3rem, 8vh, 5rem)' }}>
                    <h3 style={{ 
                        fontSize: 'var(--fs-2xl)', 
                        fontWeight: 800, 
                        marginBottom: '1.5rem', 
                        color: '#0f172a',
                        letterSpacing: '-0.03em'
                    }}>
                        {section.heading}
                    </h3>
                    <div className="seo-text-block" style={{ fontSize: 'var(--fs-lg)', color: '#475569', fontWeight: 500 }}>
                        {typeof section.content === 'string' ? (
                            section.content.split('\n\n').map((para, pIdx) => (
                                <p key={pIdx} style={{ marginBottom: '1.5rem', lineHeight: '1.9' }}>{para}</p>
                            ))
                        ) : (
                            section.content
                        )}
                    </div>
                </section>
            ))}

            <div style={{ 
                marginTop: '6rem', 
                padding: '3rem', 
                background: '#f8fafc', 
                border: '1px solid #e2e8f0', 
                borderRadius: '32px' 
            }}>
                <h3 style={{ fontSize: 'var(--fs-xl)', fontWeight: 800, marginBottom: '2rem', color: '#0f172a' }}>
                    Technical Auditing & Local Execution Review
                </h3>
                <div className="table-container">
                    <table style={{ background: '#fff' }}>
                        <thead style={{ background: '#f1f5f9' }}>
                            <tr>
                                <th style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Metric</th>
                                <th style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Standard Compliance</th>
                                <th style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Verification Method</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0', fontWeight: 700 }}>Where Data Lives</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Your Local Device</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Check your browser network tab</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0', fontWeight: 700 }}>Math Accuracy</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Standard JS Numbers</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Tested against real test cases</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0', fontWeight: 700 }}>Privacy Guarantee</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>No Server Storage</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Files stay in your memory heap</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0', fontWeight: 700 }}>Tool Uptime</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Always Available</td>
                                <td style={{ padding: '1rem', border: '1px solid #e2e8f0' }}>Static files served via edge CDN</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p style={{ fontSize: '0.95rem', color: '#64748b', marginTop: '2rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                    Note: We publish these operational parameters so you know exactly how your files and strings are handled. Every tool in this directory runs under the same offline security model, keeping your private work strictly on your own hardware.
                </p>
            </div>
        </div>
    );
}




